// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1eCaL","consentsList":"PatientConsents_consentsList__2GmNU","consentsListEmpty":"PatientConsents_consentsListEmpty__2ESZ0"};